import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import type {
  Order,
  OrderSearchOutput,
  OrderSearchInput,
} from '@repo/api-contract';
import ApiClient from '../../util/api-client';
type SearchBy = OrderSearchInput['searchBy'];

export interface OrderBrowseState {
  searchInput: string;
  results?: OrderSearchOutput;
  searchBy: SearchBy;
  loading: boolean;
  activeSelection?: Order;
}

// Initialize state
const initialState: OrderBrowseState = {
  searchInput: '',
  results: undefined,
  searchBy: 'companyName',
  loading: false,
  activeSelection: undefined,
};

export const orderBrowseSlice = createSlice({
  name: 'orderBrowse',
  initialState,
  reducers: {
    setSearchInput: (state, action: PayloadAction<string>) => ({
      ...state,
      searchInput: action.payload,
    }),
    setSearchBy: (state, action: PayloadAction<SearchBy>) => ({
      ...state,
      searchBy: action.payload,
    }),
    setResults: (
      state,
      action: PayloadAction<OrderSearchOutput | undefined>,
    ) => ({
      ...state,
      results: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setActiveSelection: (state, action: PayloadAction<Order>) => ({
      ...state,
      activeSelection: action.payload,
    }),
  },
});

export const {
  setSearchInput,
  setSearchBy,
  setResults,
  setLoading,
  setActiveSelection,
} = orderBrowseSlice.actions;
export default orderBrowseSlice.reducer;

// Thunks
export const searchOrders =
  (searchInput: OrderSearchInput) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const results = await ApiClient.searchOrders.query(searchInput);
      dispatch(setResults(results));
    } catch (error: unknown) {
      dispatch(setResults(undefined));
    } finally {
      dispatch(setLoading(false));
    }
  };
